var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBid4ItLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 70,
    viewBox: "0 0 266 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5392_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.859 0H211.211V13.8448H225.486V70H240.12V13.8448H252.859V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22 0H187.586V70H202.22V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54 0H49.9062V70H64.54V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.998 56.9102H252.859V70.019H265.998V56.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.702 0L136.93 42.6883V55.6579H164.702V70H179.336V0H164.702ZM150.686 42.1711L164.702 21.4635V42.1711H150.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4122 0H73.1719V70H98.4122C98.4122 70 131.687 68.3689 131.687 34.9901C131.687 1.61125 98.4122 0 98.4122 0ZM97.1561 56.9111C90.8959 57.667 87.8057 56.9111 87.8057 56.9111V13.8448H97.6546C97.6546 13.8448 118.668 15.0781 118.409 34.4928C118.15 53.9074 103.396 56.1552 97.1362 56.9111H97.1561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4816 35.0099C37.4816 35.0099 43.1238 33.5777 43.1039 20.5882C43.6222 3.9983 25.978 0 25.978 0H0V70H25.978C25.978 70 43.6222 66.0017 43.1039 49.4118C43.1039 36.4422 37.4816 34.9901 37.4816 34.9901V35.0099ZM15.3515 57.2293V42.7479C15.3515 42.7479 29.6065 40.9974 29.6065 49.4913C29.6065 57.9852 21.2329 56.8514 15.3515 57.2293ZM15.3515 28.3262V13.8448C15.3515 13.8448 29.6065 12.0943 29.6065 20.5882C29.6065 29.0821 21.2329 27.9483 15.3515 28.3262Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5392_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid4ItLogo);
export default __webpack_public_path__ + "static/media/Bid4itLogo.5f941189bdffd2a74c8bdfc9084c6317.svg";
export { ForwardRef as ReactComponent };